<template>
  <div 
    class="flex items-center justify-between"
    ref="menuWrapper"
  >
    <div ref="left">
      <slot 
        name="left" 
        v-bind="{ contractLeft }"
      />
    </div>
    <div ref="right">
      <slot 
        name="right" 
        v-bind="{ contractRight }"
      />
    </div>
  </div>
</template>

<script>
import throttle from 'lodash/throttle'

export default {
  props: {
    offset: {
      type: Number,
      default: 10
    },
  },
  data() {
    return {
      contractLeft: false,
      contractOffset: 0,
      contractRight: false,
      contractedRightWidth: null,
      expandedLeftWidth: null,
      expandedRightWidth: null,
      menuWrapperObserver: null,
    }
  },
  methods: {
    onResize() {
      const menuWrapperWidth = this.$refs.menuWrapper.offsetWidth

      if (this.expandedLeftWidth + this.expandedRightWidth + this.contractOffset <= menuWrapperWidth) {
        this.contractRight = false
        this.contractLeft = false
      } else if (this.expandedLeftWidth + this.contractedRightWidth + this.contractOffset <= menuWrapperWidth) {
        this.contractRight = true
        this.contractLeft = false
      } else {
        this.contractRight = true
        this.contractLeft = true
      }
    },
  },
  mounted() {
    this.expandedLeftWidth = this.$refs.left.offsetWidth
    this.expandedRightWidth = this.$refs.right.offsetWidth
    this.contractRight = true
    if (this.expandedRightWidth) {
      this.contractOffset = this.offset
    }

    this.$nextTick(() => {
      this.contractedRightWidth = this.$refs.right.offsetWidth
      this.menuWrapperObserver = new ResizeObserver(throttle(this.onResize))
      this.menuWrapperObserver.observe(this.$refs.menuWrapper)
    })
  },
  beforeUnmount() {
    this.menuWrapperObserver.disconnect()
  },
}
</script>
